import React, { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import { NextSeo } from 'next-seo'
import { useForm } from 'react-hook-form'

import { Column, Text, Checkbox } from '../src/components'
import { ButtonWhatsSup, ButtonEmailSup, ButtonDivInfo } from '../src/routes/CommonQuestions/style'

import { useUser } from 'context/user-context'

const ContactUs = () => {
  const router = useRouter()

  const { user } = useUser()

  const { control } = useForm()

  const [logged, setLogged] = useState(false)
  const [checked, setChecked] = useState(false)

  useEffect(() => {
    if (!!user) {
      setLogged(true)
    }
  }, [user, setLogged])

  return (
    <Column alignItems='center' width='100%' pt={logged ? '152px' : '112px'} pl={2} pr={2}>
      <NextSeo title='Kavod Lending - Fale conosco' description='KavodLending | Peer to Peer lending' />
      <Text variant='h3'>Comunicado importante</Text>

      <div style={{ width: '100%', maxWidth: '800px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
        <p variant='h4'>
          Gostaríamos de informar que,
          <strong> desde o dia 23/08/2022, novas captações foram suspensas na Kavod.</strong>
        </p>
        <p variant='h4'>
          Depois de 5 anos desbravando e operando no mercado de peer to peer no Brasil, chegou a hora de explorar novos
          horizontes e modelos de operação, saíndo do peer to peer.{' '}
        </p>
        <p variant='h4'>
          Gostaríamos de ressaltar, todavia, que
          <strong>
            {' '}
            nossa equipe continuará dando todo o suporte necessário para acompanhamento das operações em andamento e das
            execuções judiciais.
          </strong>
        </p>
        <p variant='h4'>
          Além disso,
          <strong>
            {' '}
            o site e dashboard do investidor continuarão ativos e serão atualizados normalmente até o vencimento da
            última operação.
          </strong>
        </p>
        <p variant='h4'>
          Informamos também que os{' '}
          <strong> canais de atendimento ao cliente, whatsapp e e-mail, permanecerão disponíveis.</strong>
        </p>
        <p variant='h4'>
          Em suma, as operações atuais manterão o mesmo nível de atendimento e novas captações estarão suspensas.
        </p>
        <p variant='h4'>Nos colocamos à disposição para responder qualquer dúvida através dos canais abaixo.</p>
        <Checkbox
          control={control}
          name='checkButton'
          label='Confirmo que estou ciente que a empresa encerrou as operações, já sou cliente e desejo entrar em contato com o suporte.'
          checked={checked}
          onChange={() => {
            setChecked(!checked)
          }}
        />
      </div>

      {checked && (
        <ButtonDivInfo>
          <ButtonWhatsSup
            color='secondary'
            onClick={() => {
              window.open(
                'https://api.whatsapp.com/send?phone=5511975052863&text=Oi%20KavodLending%21%20Voc%C3%AA%20pode%20me%20ajudar%3F',
                '_blank'
              )
            }}
          >
            <img src='/img/whats.svg' alt='paper' /> Suporte via Whatsapp
          </ButtonWhatsSup>
          <ButtonEmailSup
            width={274}
            color='primary'
            style={{ heigth: '52px' }}
            onClick={() => {
              router.push('/fale-conosco')
            }}
          >
            Suporte via E-mail
          </ButtonEmailSup>
        </ButtonDivInfo>
      )}

      <p>
        Agradecemos a atenção,<strong> Equipe Kavod</strong>
      </p>
    </Column>
  )
}

export default ContactUs
